import CentreGravityEffect from "./HomeScreenSample.tsx/CentreGravityEffect";
import CentreOrbital from "./HomeScreenSample.tsx/CentreOribital";
import NormalRotate from "./HomeScreenSample.tsx/NormalRotate";
import ParticleLayer from "./HomeScreenSample.tsx/ParticleLayerBehind";

const Home = () => {
  

  return (
    <>
    <NormalRotate/>
    {/* <CentreGravityEffect/>
    <CentreOrbital/>
    <ParticleLayer/> */}
    </>
  );
};

export default Home;